export const hpTabSwitchModule = {
  name: 'HP Tab Switch',
};
